module.exports = __webpack_public_path__ + "static/snow-forecast-head-3095837cd753e4dffbecda241a7610d7.jpg";